<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Block List</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-circle-info me-1" style="color: #00A0C1;"></i>
                  Manage blocked websites and file extensions for this account. <strong>Please note:</strong> It may take up to 30 minutes for this change to be reflected in your browser. Page refresh is required.
               </small>
            </div>
         </div>
      </div>

      <!-- Tabs -->
      <ul class="nav blocklist-tabs mt-3 ms-2">
         <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'websites' }"
               @click="activeTab = 'websites'" href="#" id="tab-blocked-websites">
               <i class="fa-solid fa-globe me-1"></i> Blocked Websites
            </a>
         </li>
         <li class="nav-item">
            <a class="nav-link" :class="{ active: activeTab === 'extensions' }"
               @click="activeTab = 'extensions'" href="#" id="tab-blocked-file-extensions">
               <i class="fa-solid fa-file-zipper me-1"></i> Blocked File Extensions
            </a>
         </li>
      </ul>

      <!-- Tab hint for Blocked Websites -->
      <div class="mt-2 ms-2" v-if="activeTab === 'websites'">
         <small class="text-muted">
            <i class="fa-solid fa-circle-info me-1" style="color: #00A0C1;"></i>
            Use the <strong>domainname.com</strong> format when adding websites. Wildcards (<strong>*.example.com</strong>, <strong>example.com/path/*</strong>), CIDR notation (<strong>192.168.1.0/24</strong>), IPs, and localhost are also supported. Ports are ignored by default. <strong>Note: localhost is always allowed.</strong>
         </small>
      </div>

      <BlockList v-if="activeTab === 'websites'" />
      <BlockedFileExtensions v-if="activeTab === 'extensions'" :settings="settings" />
   </div>
</template>

<script>
import BlockList from '@/components/BlockList/BlockList.vue';
import BlockedFileExtensions from '@/components/BlockList/BlockedFileExtensions.vue';

export default {

   components: {
      BlockList,
      BlockedFileExtensions,
   },

   data() {
      return {
         activeTab: 'websites',
         settings: null,
      }
   },

   created() {
      if (this.$route.query.tab === 'extensions') {
         this.activeTab = 'extensions';
      }
      this.getAccountSettings();
   },

   watch: {
      '$route.query.tab'(newTab) {
         if (newTab === 'extensions') {
            this.activeTab = 'extensions';
         } else {
            this.activeTab = 'websites';
         }
      }
   },

   methods: {
      getAccountSettings() {
         this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-settings")
            .then((response) => {
               this.settings = response.data.settings;
            })
            .catch(() => {})
      }
   }

}

</script>

<style scoped>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}

.custom-span-no-weight {
   font-size: 24px;
   line-height: 24px;
   font-weight: 250;
}

/* Tabs — must override global .nav .nav-link sidebar styles from app.css */
.blocklist-tabs {
   border-bottom: 2px solid #e9ecef !important;
}

.blocklist-tabs .nav-item {
   padding: 0 !important;
}

.blocklist-tabs .nav-link {
   cursor: pointer !important;
   color: #6c757d !important;
   font-weight: 500 !important;
   font-size: 14px !important;
   border: none !important;
   border-bottom: 3px solid transparent !important;
   border-radius: 8px 8px 0 0 !important;
   padding: 0.65rem 1.2rem !important;
   height: auto !important;
   width: auto !important;
   background: transparent !important;
   box-shadow: none !important;
   display: inline-flex !important;
   align-items: center !important;
   transform: none !important;
   transition: all 0.2s ease !important;
}

.blocklist-tabs .nav-link:hover {
   color: #435666 !important;
   background: rgba(0, 160, 193, 0.06) !important;
   border-bottom-color: #dee2e6 !important;
   transform: none !important;
}

.blocklist-tabs .nav-link.active {
   color: #fff !important;
   background: #00A0C1 !important;
   border-bottom-color: #00A0C1 !important;
   font-weight: 600 !important;
   box-shadow: none !important;
}
</style>
